import { render, staticRenderFns } from "./CourseRightForYou.vue?vue&type=template&id=9ec2850e&"
import script from "./CourseRightForYou.vue?vue&type=script&lang=js&"
export * from "./CourseRightForYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports